import { PartialTranslation } from '../translations';

export const vi: PartialTranslation = {
  newChat: 'Cuộc trò chuyện mới',
  search: 'Tìm kiếm',
  user: 'Người dùng',
  settings: 'Cài đặt',
  language: 'Ngôn ngữ',
  getHelp: 'Nhận trợ giúp',
  viewAllPlans: 'Xem tất cả gói',
  learnMore: 'Tìm hiểu thêm',
  logOut: 'Đăng xuất',
  chooseLanguage: 'Chọn ngôn ngữ',
  chooseYourPreferredLanguage: 'Chọn ngôn ngữ ưa thích của bạn',
  searchLanguages: 'Tìm kiếm ngôn ngữ...',
  autoDetect: 'Tự động phát hiện',
  noLanguagesFound: 'Không tìm thấy ngôn ngữ',
  askAnything: 'Hỏi bất cứ điều gì',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Cá nhân',
  freePlan: 'Gói miễn phí',
  current: 'Hiện tại',
  close: 'Đóng',
  archive: 'Lưu trữ',
  delete: 'Xóa',
  confirmDelete: 'Bạn có chắc chắn muốn xóa cuộc trò chuyện này không?',
  confirmArchive: 'Bạn có chắc chắn muốn lưu trữ cuộc trò chuyện này không?',
  deleteCannotUndo: 'Hành động này không thể hoàn tác.',
  archiveCanFind: 'Bạn có thể tìm thấy nó trong danh sách lưu trữ sau khi lưu trữ.',
  
  // 资源面板
  resources: 'Tài nguyên',
  addResource: 'Thêm tài nguyên',
  deleteResource: 'Xóa tài nguyên',
  noMatchingResourcesFound: 'Không tìm thấy tài nguyên phù hợp',
  noResourcesAvailable: 'Không có tài nguyên khả dụng',
  hideResources: 'Ẩn tài nguyên',
  showResources: 'Hiển thị tài nguyên',
  
  // 聊天输入框
  typeMessage: 'Nhập tin nhắn...',
  thinkingOptions: 'Tùy chọn suy nghĩ',
  deleteFile: 'Xóa tệp',
  clearSelection: 'Xóa lựa chọn',
  addAttachment: 'Thêm tệp đính kèm',
  sendMessage: 'Gửi tin nhắn',
  
  // 思考模式选项
  deepInsight: 'Hiểu biết sâu sắc · Phân tích bề mặt',
  deepInsightDesc: 'Hiểu nhanh các điểm chính',
  deepExploration: 'Khám phá sâu · Phân tích toàn diện',
  deepExplorationDesc: 'Nghiên cứu sâu đa chiều',
  deepDeconstruction: 'Giải cấu trúc sâu · Lập luận có hệ thống',
  deepDeconstructionDesc: 'Phân tích từng lớp một cách tiến bộ',
  
  // 写作模式选项
  contractReview: 'Xem xét hợp đồng · Xác định rủi ro',
  contractReviewDesc: 'Phân tích điều khoản và kiểm tra tuân thủ',
  textPolish: 'Chỉnh sửa văn bản · Biểu đạt chuyên nghiệp',
  textPolishDesc: 'Tối ưu hóa ngôn ngữ và điều chỉnh cấu trúc',
  legalDocuments: 'Tài liệu pháp lý · Soạn thảo tiêu chuẩn',
  legalDocumentsDesc: 'Viết tài liệu pháp lý chuyên nghiệp',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Đăng nhập',
  register: 'Đăng ký',
  welcomeBack: 'Chào mừng đến với LawHelper',
  loginSubtitle: 'Trợ lý Nghiên cứu Pháp luật AI của bạn',
  continueWithGoogle: 'Tiếp tục với Google',
  continueWithMicrosoft: 'Tiếp tục với Microsoft',
  continueWithWeChat: 'Tiếp tục với WeChat',
  orContinueWith: 'hoặc tiếp tục với',
  emailTab: 'Email',
  phoneTab: 'Điện thoại',
  emailPlaceholder: 'Nhập email của bạn',
  phonePlaceholder: 'Nhập số điện thoại',
  codePlaceholder: 'Nhập mã 6 chữ số',
  sending: 'Đang gửi...',
  verifying: 'Đang xác minh...',
  verify: 'Xác minh',
  sendMagicLink: 'Gửi liên kết kỳ diệu',
  getVerificationCode: 'Lấy mã',
  resendCode: 'Gửi lại mã',
  resendIn: 'Gửi lại sau',
  magicLinkSent: 'Liên kết kỳ diệu đã được gửi đến email của bạn',
  magicLinkHint: 'Chúng tôi sẽ gửi một liên kết bảo mật đến email của bạn',
  otpSent: 'Mã xác minh đã được gửi',
  agreeToTerms: 'Bằng cách tiếp tục, bạn đồng ý với',
  privacyPolicy: 'Chính sách bảo mật',
  termsOfService: 'Điều khoản dịch vụ',
  and: 'và',
  privacyTitle: 'Quyền riêng tư của bạn rất quan trọng',
  privacyIntro: 'Chúng tôi sử dụng cookie và các công nghệ tương tự để mang đến trải nghiệm tốt nhất cho bạn.',
  essentialCookies: 'Cookie thiết yếu',
  essentialDesc: 'Cần thiết để trang web hoạt động',
  analyticsCookies: 'Cookie phân tích',
  analyticsDesc: 'Giúp chúng tôi cải thiện dịch vụ',
  marketingCookies: 'Cookie tiếp thị',
  marketingDesc: 'Được sử dụng cho nội dung cá nhân hóa',
  acceptAll: 'Chấp nhận tất cả',
  essentialOnly: 'Chỉ thiết yếu',
  customize: 'Tùy chỉnh',
  savePreferences: 'Lưu tùy chọn',
  back: 'Quay lại',
  readPrivacyPolicy: 'Đọc chính sách bảo mật của chúng tôi',
  cookiePolicy: 'Chính sách cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Kiểm tra AI',
  aiDraft: 'Soạn thảo AI',
  smartAssistant: 'Mẫu',

  // 知识库搜索
  enableKnowledgeSearch: 'Kích hoạt tìm kiếm',
  knowledgeSearchDesc: 'AI tìm trong tài liệu của bạn',
  clickToDisable: 'Tắt',
  clickToEnable: 'Bật',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Đóng bảng tài nguyên',
  uploading: 'Đang tải lên %{fileName}...',
  processing: 'Đang xử lý %{fileName}...',
  uploadSuccess: '✓ Đã tải lên %{fileName}',
  uploadError: '✗ Tải lên thất bại: %{error}',
  quickAnswer: 'Trả lời nhanh',
  quickAnswerDesc: 'Trả lời nhanh câu hỏi đơn giản',
  cancelRequest: 'Hủy',
  library: 'Thư viện',
  filterAll: 'Tất cả',
  filterChat: 'Trò chuyện',
  filterReview: 'Xem xét',
  filterDraft: 'Bản nháp',
  filterTemplate: 'Mẫu',
  filterForm: 'Biểu mẫu',
  thinking: 'Đang suy nghĩ...',
  thinkingProcess: 'Quá trình suy nghĩ',
  analyzingLegalLogic: 'Phân tích logic pháp lý...',
  lawhelperThinking: 'Lawhelper đang suy nghĩ...',
  serviceError: 'Lỗi dịch vụ',
  uploaded: 'Đã tải lên',
  settingsGeneral: 'Chung',
  settingsNotifications: 'Thông báo',
  settingsAppearance: 'Giao diện',
  settingsProfile: 'Hồ sơ',
  settingsResponseNotifications: 'Thông báo phản hồi',
  settingsResponseNotificationsDesc: 'Thông báo khi AI hoàn thành phản hồi',
  settingsColorMode: 'Chế độ màu',
  settingsLight: 'Sáng',
  settingsDark: 'Tối',
  settingsSystem: 'Hệ thống',
  about: 'Giới thiệu',
  reviewTitle: 'Xem xét tài liệu',
  exitReview: 'Thoát xem xét',
  uploadPrompt: 'Tải lên PDF để xem xét',
  uploadButton: 'Chọn tệp',
  startChatConfig: 'Nhập "Xem xét tài liệu này"',
  reviewPlaceholder: 'Nhập tin nhắn...',
  analyzing: 'Đang xem xét...',
  reviewComplete: 'Xem xét hoàn tất',
  issuesFound: 'Tìm thấy %{count} vấn đề',
  draftTitle: 'Soạn thảo tài liệu pháp lý',
  draftPlaceholder: 'Chỉnh sửa tại đây hoặc yêu cầu AI...',
  analyzingTemplate: 'Phân tích mẫu %{name}...',
  templateAnalyzed: '✅ Đã phân tích mẫu %{name}!',
  templateAnalysisPrompt: 'Phân tích các điều khoản chính',
  parsingFailed: '⚠️ Không thể phân tích tệp.',
  generating: 'Đang tạo...',
  generatedSuccess: '✅ Tài liệu đã được tạo!',
  drafterWelcome: 'Chào mừng đến Trợ lý tài liệu AI',
  drafterYouCan: 'Bạn có thể:',
  drafterUploadTemplate: 'Tải lên mẫu để AI phân tích',
  drafterDescribeNeeds: 'Mô tả yêu cầu tài liệu',
  drafterLetAiHelp: 'AI giúp soạn hợp đồng, thỏa thuận...',
  drafterExamples: 'Ví dụ:',
  drafterExampleRental: '"Soạn hợp đồng thuê nhà"',
  drafterExampleLabor: '"Điền hợp đồng lao động"',
  drafterInputPlaceholder: 'Mô tả nhu cầu của bạn...',
  drafterThinking: 'Đang suy nghĩ...',
  drafterHistoryTitle: 'Lịch sử',
  drafterNoHistory: 'Chưa có lịch sử',
  drafterNewChat: 'Cuộc trò chuyện mới',
  drafterHistory: 'Lịch sử',
  drafterRemoveAttachment: 'Xóa tệp đính kèm',
  drafterLineHeight: 'Chiều cao dòng',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Xuất Word (.docx)',
  drafterExportPdf: 'Xuất PDF',
  drafterSave: 'Lưu tài liệu',
  drafterDownload: 'Tải tài liệu',
  drafterUndo: 'Hoàn tác',
  drafterRedo: 'Làm lại',
  drafterBold: 'In đậm',
  drafterItalic: 'In nghiêng',
  drafterStrike: 'Gạch ngang',
  drafterUnderline: 'Gạch dưới',
  drafterHighlight: 'Đánh dấu',
  drafterLink: 'Chèn liên kết',
  drafterAlignLeft: 'Căn trái',
  drafterAlignCenter: 'Căn giữa',
  drafterAlignRight: 'Căn phải',
  drafterAlignJustify: 'Căn đều',
  drafterList: 'Danh sách',
  drafterBulletList: 'Danh sách dấu đầu dòng',
  drafterOrderedList: 'Danh sách đánh số',
  drafterTaskList: 'Danh sách nhiệm vụ',
  drafterOpenResource: 'Mở bảng tài nguyên',
  drafterStopGeneration: 'Dừng tạo',
  drafterAgentMode: 'Chế độ Agent đang bật',
  drafterAgentModeOn: 'Chế độ Agent đang bật',
  drafterAgentModeOff: 'Chế độ thường',
  drafterUploadAttachment: 'Tải lên tệp đính kèm',
  drafterExit: 'Thoát',
  drafterConfirm: 'Xác nhận',
  drafterOpenLink: 'Mở liên kết',
  drafterDeleteLink: 'Xóa liên kết',
  drafterQuote: 'Trích dẫn',
  workflowTitle: 'Quy trình AI',
  workflowRunning: 'Đang chạy...',
  workflowReady: 'Sẵn sàng',
  workflowCompleted: 'Hoàn tất',
  workflowStartFailed: 'Không thể bắt đầu quy trình',
  workflowExecutionFailed: 'Thực hiện quy trình thất bại',
  workflowInterrupted: 'Quy trình bị gián đoạn',
  workflowProcessing: 'Đang xử lý...',
  workflowStepsCompleted: 'bước hoàn tất',
  workflowStepsTotal: 'Quy trình hoàn tất (%{count} bước)',
  acceptChanges: 'Chấp nhận thay đổi',
  rejectChanges: 'Từ chối thay đổi',
  changesAccepted: 'Đã chấp nhận',
  changesRejected: 'Đã từ chối',
  stopWorkflow: 'Dừng',
  restartWorkflow: 'Khởi động lại',
  startDrafting: 'Bắt đầu soạn thảo',
  interrupt: 'Dừng',
  documentSubject: 'Chủ đề tài liệu *',
  documentType: 'Loại tài liệu',
  jurisdiction: 'Thẩm quyền',
  specialRequirements: 'Yêu cầu đặc biệt (tùy chọn)',
  clickStartDrafting: 'Nhấn "Bắt đầu soạn thảo"',
  docTypeContract: 'Hợp đồng',
  docTypeAgreement: 'Thỏa thuận',
  docTypeNotice: 'Thông báo',
  docTypeLetter: 'Thư',
  docTypePetition: 'Đơn kiến nghị',
  docTypeWill: 'Di chúc',
  docTypePowerOfAttorney: 'Giấy ủy quyền',
  countryChina: 'Trung Quốc',
  countryUSA: 'Hoa Kỳ',
  countryGermany: 'Đức',
  countryJapan: 'Nhật Bản',
  countryFrance: 'Pháp',
  countryUK: 'Vương quốc Anh',
  citationVerified: 'Đã xác minh',
  citationUnverified: 'Chưa xác minh',
  imageLoadFailed: 'Tải ảnh thất bại',
  smartDocTitle: 'Trợ lý tài liệu thông minh',
  smartDocChatTitle: 'Trợ lý tài liệu AI',
  smartDocDropPrompt: 'Thả tệp PDF vào đây',
  smartDocSelectFile: 'Chọn tệp',
  smartDocOr: 'hoặc',
  smartDocWelcomeTitle: 'Chào mừng đến Trợ lý AI',
  smartDocWelcomeYouCan: 'Bạn có thể:',
  smartDocUploadForAI: 'Tải lên mẫu',
  smartDocDescribeDoc: 'Mô tả yêu cầu',
  smartDocLetAIDraft: 'AI giúp soạn hợp đồng',
  smartDocExamples: 'Ví dụ:',
  smartDocExampleRental: '"Soạn hợp đồng thuê nhà"',
  smartDocExampleLabor: '"Điền hợp đồng lao động"',
  smartDocInputPlaceholder: 'Mô tả nhu cầu...',
  smartDocRemoveAttachment: 'Xóa tệp đính kèm',
  smartDocOpenResources: 'Mở tài nguyên',
  smartDocExit: 'Thoát',
  reviewStartFailed: 'Không thể bắt đầu xem xét',
  reviewFailed: 'Xem xét thất bại',
  reviewFoundIssues: 'Xem xét hoàn tất, %{count} vấn đề.',
  cannotReadStream: 'Không thể đọc luồng phản hồi',
  parseEventFailed: 'Phân tích sự kiện thất bại',
  errorPrefix: 'Lỗi',
  unknownError: 'Lỗi không xác định',
  file: 'Tệp',
  loading: 'Đang tải...',
  localFolders: 'Thư mục cục bộ',
  selectLocalFolder: 'Chọn thư mục cục bộ',
  reselectFolder: 'Đổi thư mục',
  addToContext: 'Thêm vào trò chuyện',
  saveFile: 'Lưu',
  renameFile: 'Đổi tên',
  fileSaved: 'Đã lưu tệp',
  fileRenamed: 'Đã đổi tên tệp thành %{name}',
  browserNotSupported: 'Trình duyệt không hỗ trợ truy cập thư mục',
  noFolderSelected: 'Chọn thư mục cục bộ',
  scanningFolder: 'Đang quét thư mục...',
  selectFileToPreview: 'Chọn tệp để xem trước',
  aiAnalyze: 'Phân tích AI',
};
